import { apiClient } from '../client';

export interface DashboardActivity {
  id: number;
  type: string | null;
  notes: string;
  startDate: string | null;
  endDate: string | null;
  closed: boolean;
  accountNameSnapshot: string | null;
  personNameSnapshot: string | null;
  account?: { id: number; name: string } | null;
  person?: { id: number; firstName: string | null; lastName: string } | null;
}

export interface DashboardSummary {
  myToday: DashboardActivity[];
  myOverdue: DashboardActivity[];
  myUpcoming: DashboardActivity[];
  counters: {
    myOpenActivities: number;
    myClosedLast7Days: number;
    totalAccounts: number;
    totalPersons: number;
    pendingSales: number;
    wonSalesCountThisMonth: number;
    wonSalesAmountThisMonth: string | null;
  };
  recentActivities: DashboardActivity[];
  favoriteAccounts: Array<{ id: number; name: string }>;
  charts: {
    activityNext7Days: Array<{ day: string; count: number }>;
    myPipelineByStage: Array<{ stage: string; count: number; amount: number }>;
  };
}

export const dashboardApi = {
  async summary(): Promise<DashboardSummary> {
    const { data } = await apiClient.get<DashboardSummary>('/dashboard');
    return data;
  },
};
